<app-crud-create [fields]="fields" [title]="'materia'"
  [description]="'En esta sección podrás ingresar el detalle de la Materia'" [apiService]="apiService">
</app-crud-create>
